import { baseApi } from './baseApi'
import { CreateTagDto, TagDto, UpdateTagDto } from 'store/types'

export const tagsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createTag: builder.mutation<{ message: string }, CreateTagDto>({
      query: (body) => ({ url: '/lab/tags', method: 'POST', body }),
      invalidatesTags: ['Tag'],
    }),
    getTag: builder.query<TagDto, { id: string; includeDeleted?: boolean }>({
      query: ({ id, includeDeleted }) => ({
        url: `/lab/tags/${id}`,
        params: includeDeleted ? { includeDeleted: true } : undefined,
      }),
      providesTags: ['Tag'],
    }),
    getTags: builder.query<TagDto[], undefined>({
      query: () => ({ url: '/lab/tags' }),
      providesTags: ['Tag'],
    }),
    updateTag: builder.mutation<{ message: string }, Partial<UpdateTagDto> & { id: string }>({
      query: ({ id, ...data }) => ({
        url: `/lab/tags/${id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Tag'],
    }),
    deleteTag: builder.mutation<{ message: string }, string>({
      query: (id) => ({ url: `/lab/tags/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Tag'],
    }),
  }),
})

export const {
  useCreateTagMutation,
  useDeleteTagMutation,
  useGetTagQuery,
  useGetTagsQuery,
  useUpdateTagMutation,
} = tagsApi
